import React, { useState, useRef, useEffect } from "react";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";
import { navigate } from "gatsby";

// Components
import TitleSection from "../../molecules/title-section";
import Modal from "../../ui/modal/Modal";
import Button from "../../atoms/button/button";

// Icons
import checkCirculo from "../../../../src/assets/images/icons/circle-check.svg";
import equisCirculo from "../../../../src/assets/images/icons/circle-x.svg";

// Styles
import "./requerimentsAppMpc.scss";

interface RequerimentsAppMpcProps {
    tituloGeneral: string;
    tituloBoton: string;
    redireccionBoton: string;
    referenciaPlantillaContenido: any;
    referenciaFormulario: any;
    descripcion: any; // Update the type according to your needs
}

interface Card {
    id: string;
    isChecked: boolean;
}

const RequerimentsAppMpc = (props: RequerimentsAppMpcProps) => {
    const { 
        tituloGeneral, 
        descripcion,
        referenciaPlantillaContenido,
        referenciaFormulario
    } = props;

    const [selectedCards, setSelectedCards] = useState<Card[]>([]);
    const [showModalDisabled, setShowModalDisabled] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isExpanded, setIsExpanded] = useState(-1);
    const [cards, setCards] = useState(() => referenciaFormulario.map(item => {
        return {
            text: item.textoTerminos ? item.textoTerminos : false,
            link: item.tituloBotonTerminos ? item.tituloBotonTerminos : false,
            url: item.placeholder ? item.placeholder : false,
            option1: false,
            option2: false
        }
    }))
    const urlFosfec = process.env.URL_FORM_FOSFEC;
    const isOdd = cards.length % 2 ? true : false;
    const half = isOdd ? Math.round(cards.length / 2) : cards.length / 2;
    const firstColumn = cards.slice(0, half);
    const secondColumn = cards.slice(half, cards.length);
    const refs = useRef<any>([]);

    const buttonModal = () => {
        if (showModal) {
            if (urlFosfec) {
                navigate(urlFosfec);
            }
        } else {
            navigate(
                "https://www.comfama.com/servicio-de-empleo/personas/subsidio-de-desempleo"
            );
        }
    };

    const handleCardClick = (cardId: string) => {
        setSelectedCards((prevSelectedCards) => {
            const updatedCards = prevSelectedCards.map((card) => ({
                ...card,
                isChecked: card.id === cardId,
            }));
            return updatedCards;
        });
    };

    const handleCheckboxChange = (index, option) => {
        const updatedCards = [...cards];

        updatedCards[index] = {
            ...updatedCards[index],
            option1: option === "option1",
            option2: option === "option2",
        };
        if (updatedCards.filter((item) => item.option1).length === cards.length) {
            setShowModal(true);
        }else if (updatedCards.filter((item) => item.option2).length === cards.length){
            setShowModalDisabled(true);
        }
        setCards(updatedCards);
    };

    const handleShowMore = (e) => {
        const index = parseInt(e.target.id, 0);
        if (index !== isExpanded) {
            setIsExpanded(index);
        } else {
            setIsExpanded(-1);
        }
    }

    return (
        <>
            <div className="o-requeriments-app-mpc">
                <div className="container">
                    <div className="o-requeriments-app-mpc__container">
                        <TitleSection title={tituloGeneral} />
                        {descripcion && contentfulRenderOptions(descripcion.json)}
                        <div className="o-requeriments-app-mpc__container__img">
                            <figure>
                                <h3>
                                    Selecciona el check
                                    <img
                                        src={checkCirculo}
                                        alt="Check"
                                        className="light-mode-icon"
                                    />
                                    en los requisitos que tienes cumplidos, en caso de que te falte completar alguno, selecciona 
                                    <img
                                        src={equisCirculo}
                                        alt="Error"
                                        className="light-mode-icon"
                                    />
                                </h3>
                            </figure>
                        </div>
                    </div>
                </div>
                <div className="o-requeriments-app-mpc-cards">
                    <div className="card-grid">
                        <div className="card-grid__column">
                            {firstColumn.map((item, index) => (
                                <div
                                    key={index}
                                    className={`cardMpc cardMpc-${index} ${
                                        selectedCards.find(
                                            (card) =>
                                                card.id === "card${index + 1}"
                                        )?.isChecked
                                            ? "selected"
                                            : ""
                                    }`}
                                    onClick={() =>
                                        handleCardClick(`card${index + 1}`)
                                    }
                                >
                                    <div className={`cardMpc__text ${isExpanded === index ? "active" : ""}`}>
                                        <div className={`cardMpc__text__inner`} 
                                            ref={(ele) => {refs.current[index] = ele;}}>
                                                {item.text && contentfulRenderOptions(item.text)}
                                                
                                        </div>
                                        {(item.text.content.length > 1 || item.text.content[0].content[0].value.length > 85) || (item.text.content[0].content[0].value.length > 52 && window.innerWidth <= 430) ? (
                                            <>
                                                <span className="more" onClick={handleShowMore} id={String(index)}>Ver más</span>
                                                <span className="less" onClick={handleShowMore} id={String(index)}>Ver menos</span>
                                            </>
                                        ): (
                                            <></>
                                        )}
                                        {item.link && (
                                            <a href={item.url ? item.url : ""} target="_blank" rel="noreferrer">{`${item.link} →`}</a> 
                                        )}
                                    </div>
                                    <div className="checkbox">
                                        <label
                                            htmlFor={`checkbox-option1-${index}`}
                                        >
                                            <input
                                                type="checkbox"
                                                id={`checkbox-option1-${index}`}
                                                checked={item.option1}
                                                onChange={() =>
                                                    handleCheckboxChange(
                                                        index,
                                                        "option1"
                                                    )
                                                }
                                                />
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24.074" height="24.074" viewBox="0 0 24.074 24.074" className={item.option1 ? "checked-option-1" : "checkbox-option1"}>
                                                <g id="Grupo_16831" data-name="Grupo 16831" transform="translate(-516.926 -3113.125)">
                                                    <g id="Radio_button" data-name="Radio button" transform="translate(516.926 3113.125)">
                                                        <g id="Rectángulo_2634" data-name="Rectángulo 2634" fill="none" stroke="#474747" strokeWidth="1">
                                                            <rect width="24.074" height="24.074" rx="12" stroke="none"/>
                                                            <rect x="0.5" y="0.5" width="23.074" height="23.074" rx="11.5" fill="none"/>
                                                        </g>
                                                    </g>
                                                    <path id="Trazado_76953" data-name="Trazado 76953" d="M4.189,79.938a1.386,1.386,0,0,1-.982-.407L.24,76.565a.818.818,0,0,1,0-1.157h0a.818.818,0,0,1,1.157,0L4.189,78.2l7.388-7.388a.818.818,0,0,1,1.157,0h0a.818.818,0,0,1,0,1.157L5.171,79.531A1.386,1.386,0,0,1,4.189,79.938Z" transform="translate(522.476 3049.866)" fill="#474747"/>
                                                </g>
                                            </svg>
                                        </label>

                                        <label
                                            htmlFor={`checkbox-option2-${index}`}
                                        >
                                            <input
                                                type="checkbox"
                                                id={`checkbox-option2-${index}`}
                                                checked={item.option2}
                                                onChange={() =>
                                                    handleCheckboxChange(
                                                        index,
                                                        "option2"
                                                    )
                                                }
                                                />
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24.074" height="24.074" viewBox="0 0 24.074 24.074" className={item.option2 ? "checked-option-2" : "checkbox-option2"}>
                                                <g id="Grupo_16832" data-name="Grupo 16832" transform="translate(-1049.926 -3113.125)">
                                                    <g id="Radio_button" data-name="Radio button" transform="translate(1049.926 3113.125)">
                                                    <g id="Rectángulo_2634" data-name="Rectángulo 2634" fill="none" stroke="#474747" strokeWidth="1">
                                                        <rect width="24.074" height="24.074" rx="12" stroke="none"/>
                                                        <rect x="0.5" y="0.5" width="23.074" height="23.074" rx="11.5" fill="none"/>
                                                    </g>
                                                    </g>
                                                    <g id="x_1_" data-name="x (1)" transform="translate(1057.091 3120.421)">
                                                    <g id="Grupo_16774" data-name="Grupo 16774" transform="translate(0 0.004)">
                                                        <path id="Trazado_77169" data-name="Trazado 77169" d="M6.21,5.328l4.255-4.255A.626.626,0,0,0,9.579.188L5.324,4.443,1.069.188a.626.626,0,1,0-.886.886L4.439,5.328.184,9.583a.626.626,0,1,0,.886.886L5.324,6.214l4.255,4.255a.626.626,0,0,0,.886-.886Z" transform="translate(0 -0.004)" fill="#474747"/>
                                                    </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="card-grid__column">
                            {secondColumn.map((item, index = 10) => (
                                <div
                                    key={index + half}
                                    className={`cardMpc cardMpc-${index + half} ${
                                        selectedCards.find(
                                            (card) =>
                                                card.id === "card${index + 1}"
                                        )?.isChecked
                                            ? "selected"
                                            : ""
                                    }`}
                                    onClick={() =>
                                        handleCardClick(`card${index + 1}`)
                                    }
                                >
                                    <div className={`cardMpc__text  ${isExpanded === index ? "active" : ""}`}>
                                        <div className={`cardMpc__text__inner`} 
                                            ref={(ele) => {refs.current[index] = ele;}}>
                                                {item.text && contentfulRenderOptions(item.text)}
                                        </div>
                                        {(item.text.content.length > 1 || item.text.content[0].content[0].value.length > 85) || (item.text.content[0].content[0].value.length > 52 && window.innerWidth <= 430)  ? (
                                            <>
                                                <span className="more" onClick={handleShowMore} id={String(index)}>Ver más</span>
                                                <span className="less" onClick={handleShowMore} id={String(index)}>Ver menos</span>
                                            </>
                                        ): (
                                            <></>
                                        )}
                                        {item.link && (
                                            <a href={item.url ? item.url : ""} target="_blank" rel="noreferrer">{`${item.link} →`}</a> 
                                        )}
                                    </div>
                                    <div className="checkbox">
                                        <label
                                            htmlFor={`checkbox-option1-${index + half}`}
                                        >
                                            <input
                                                type="checkbox"
                                                id={`checkbox-option1-${index + half}`}
                                                checked={item.option1}
                                                onChange={() =>
                                                    handleCheckboxChange(
                                                        index + half,
                                                        "option1"
                                                    )
                                                }
                                                />
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24.074" height="24.074" viewBox="0 0 24.074 24.074" className={item.option1 ? "checked-option-1" : "checkbox-option1"}>
                                                <g id="Grupo_16831" data-name="Grupo 16831" transform="translate(-516.926 -3113.125)">
                                                    <g id="Radio_button" data-name="Radio button" transform="translate(516.926 3113.125)">
                                                        <g id="Rectángulo_2634" data-name="Rectángulo 2634" fill="none" stroke="#474747" strokeWidth="1">
                                                            <rect width="24.074" height="24.074" rx="12" stroke="none"/>
                                                            <rect x="0.5" y="0.5" width="23.074" height="23.074" rx="11.5" fill="none"/>
                                                        </g>
                                                    </g>
                                                    <path id="Trazado_76953" data-name="Trazado 76953" d="M4.189,79.938a1.386,1.386,0,0,1-.982-.407L.24,76.565a.818.818,0,0,1,0-1.157h0a.818.818,0,0,1,1.157,0L4.189,78.2l7.388-7.388a.818.818,0,0,1,1.157,0h0a.818.818,0,0,1,0,1.157L5.171,79.531A1.386,1.386,0,0,1,4.189,79.938Z" transform="translate(522.476 3049.866)" fill="#474747"/>
                                                </g>
                                            </svg>
                                        </label>

                                        <label
                                            htmlFor={`checkbox-option2-${index + half}`}
                                        >
                                            <input
                                                type="checkbox"
                                                id={`checkbox-option2-${index + half}`}
                                                checked={item.option2}
                                                onChange={() =>
                                                    handleCheckboxChange(
                                                        index + half,
                                                        "option2"
                                                    )
                                                }
                                                />
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24.074" height="24.074" viewBox="0 0 24.074 24.074" className={item.option2 ? "checked-option-2" : "checkbox-option2"}>
                                                <g id="Grupo_16832" data-name="Grupo 16832" transform="translate(-1049.926 -3113.125)">
                                                    <g id="Radio_button" data-name="Radio button" transform="translate(1049.926 3113.125)">
                                                    <g id="Rectángulo_2634" data-name="Rectángulo 2634" fill="none" stroke="#474747" strokeWidth="1">
                                                        <rect width="24.074" height="24.074" rx="12" stroke="none"/>
                                                        <rect x="0.5" y="0.5" width="23.074" height="23.074" rx="11.5" fill="none"/>
                                                    </g>
                                                    </g>
                                                    <g id="x_1_" data-name="x (1)" transform="translate(1057.091 3120.421)">
                                                    <g id="Grupo_16774" data-name="Grupo 16774" transform="translate(0 0.004)">
                                                        <path id="Trazado_77169" data-name="Trazado 77169" d="M6.21,5.328l4.255-4.255A.626.626,0,0,0,9.579.188L5.324,4.443,1.069.188a.626.626,0,1,0-.886.886L4.439,5.328.184,9.583a.626.626,0,1,0,.886.886L5.324,6.214l4.255,4.255a.626.626,0,0,0,.886-.886Z" transform="translate(0 -0.004)" fill="#474747"/>
                                                    </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {showModal && (
                <Modal
                    showModal={showModal}
                    onClose={() => setShowModal(false)}
                >
                    <div className={`m-modal-container-validationMpc`}>
                        <img
                            src={referenciaPlantillaContenido[0].imagenPrincipal[0].file.url}
                            className="o-verification-mpc-response__img"
                            alt="Success"
                        ></img>
                        <h3> {referenciaPlantillaContenido[0].tituloBanner} </h3>
                        <div className="m-modal-container-validationMpc__paragraph">
                            {referenciaPlantillaContenido[0].descripcion && contentfulRenderOptions(referenciaPlantillaContenido[0].descripcion.json)}
                        </div>
                        <div className="a-button-magenta-container gtmCumpleRequisitosPostularme">
                            <Button
                                type="button"
                                classname="a-button-magenta"
                                text={referenciaPlantillaContenido[0].tituloBoton}
                                isDisabled={false}
                                onClickAction={() => {
                                    buttonModal();
                                }}
                            ></Button>
                        </div>
                    </div>
                </Modal>
            )}
            {showModalDisabled &&                 
                <Modal
                    showModal={showModalDisabled}
                    onClose={() => setShowModalDisabled(false)}
                >
                    <div className={`m-modal-container-validationMpc`}>
                        <img
                            src={referenciaPlantillaContenido[1].imagenPrincipal[0].file.url}
                            className="o-verification-mpc-response__img"
                            alt="Success"
                        ></img>
                        <h3> {referenciaPlantillaContenido[1].tituloBanner} </h3>
                        <div className="m-modal-container-validationMpc__paragraph">
                            {referenciaPlantillaContenido[1].descripcion && contentfulRenderOptions(referenciaPlantillaContenido[1].descripcion.json)}
                        </div>
                        <div className="a-button-magenta-container">
                            <Button
                                type="button"
                                classname="a-button-magenta"
                                text={referenciaPlantillaContenido[1].tituloBoton}
                                isDisabled={false}
                                onClickAction={() => {
                                    buttonModal();
                                }}
                            ></Button>
                        </div>
                    </div>
                </Modal>}
        </>
    );
};

export default RequerimentsAppMpc;
